const TEAM_ALIASES = { JAX: "JAX", JAC: "JAX", LA: "LAR", LAR: "LAR", LAC: "LAC", LV: "LV", OAK: "LV", WAS: "WAS", WSH: "WAS" };

export function normalizeName(value) {
  return String(value || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
    .replace(/\b(jr|sr|ii|iii|iv)\b\.?/g, "").replace(/[^a-z0-9]/g, "");
}

export function normalizeTeam(value) {
  const team = String(value || "").toUpperCase().replace(/[^A-Z]/g, "");
  return TEAM_ALIASES[team] || team;
}

function pwgName(row) { return row.Player ?? row.player ?? row.Name ?? row.name ?? ""; }
function pwgTeam(row) { return row.Team ?? row.team ?? row.TeamAbbrev ?? row.team_abbrev ?? ""; }
function pwgPosition(row) { return String(row.Position ?? row.position ?? row.Pos ?? "").toUpperCase(); }
function pwgGame(row) { return String(row.Game ?? row.game ?? row.Matchup ?? row.matchup ?? row["Game Info"] ?? ""); }
function identity(row) {
  const stableId = row.player_id ?? row.playerId ?? row["Player ID"] ?? row.PlayerID;
  return stableId ? `id:${stableId}` : `${normalizeName(pwgName(row))}|${normalizeTeam(pwgTeam(row))}|${pwgPosition(row)}`;
}

function positionCompatible(dk, pwg) {
  if (!pwg) return true;
  if (dk === "DST") return ["DST", "DEF", "D/ST"].includes(pwg);
  return dk === pwg;
}

function gameCompatible(dkGame, row) {
  const game = pwgGame(row).toUpperCase();
  if (!game) return true;
  const teams = String(dkGame || "").split(" ")[0].split("@").map(normalizeTeam);
  return teams.filter(Boolean).every((team) => game.replace(/[^A-Z]/g, "").includes(team));
}

export function matchDraftKingsPlayers(dkPlayers, nflRows) {
  const rows = (Array.isArray(nflRows) ? nflRows : []).filter((row) => String(row.Sport ?? row.sport ?? "NFL").toUpperCase() === "NFL");
  const results = dkPlayers.map((player) => {
    const candidates = rows.filter((row) => {
      const nameMatches = player.position === "DST"
        ? normalizeTeam(pwgTeam(row)) === normalizeTeam(player.team) && ["DST", "DEF", "D/ST"].includes(pwgPosition(row))
        : normalizeName(pwgName(row)) === normalizeName(player.name);
      return nameMatches && normalizeTeam(pwgTeam(row)) === normalizeTeam(player.team)
        && positionCompatible(player.position, pwgPosition(row)) && gameCompatible(player.gameInfo, row);
    });
    const groups = new Map();
    candidates.forEach((row) => groups.set(identity(row), [...(groups.get(identity(row)) || []), row]));
    if (groups.size === 1) return { status: "MATCHED", player, pwgRows: [...groups.values()][0] };
    if (groups.size > 1) return { status: "AMBIGUOUS", player, candidates: [...groups.values()].map((group) => group[0]) };
    return { status: "UNMATCHED", player, candidates: [] };
  });
  return {
    results,
    matched: results.filter((result) => result.status === "MATCHED"),
    ambiguous: results.filter((result) => result.status === "AMBIGUOUS"),
    unmatched: results.filter((result) => result.status === "UNMATCHED"),
  };
}
